<template>
  <transition enter-active-class="animated fadeInRight" leave-active-class="animated fadeOutRight">
    <div v-if="opened" class="ui-in-cart-notification">
      <div class="content">
        <div class="image">
          <img class="abs" :src="product.image" :alt="product.name" />
        </div>
        <div class="data">
          <div style="margin-bottom: .5em;" class="s-18 w-600">Товар добавлен в корзину</div>
          <div class="s-16">{{ product.name }}</div>
          <div class="s-16 w-600" v-html="product.price"></div>
        </div>
      </div>
      <div class="buttons row-between">
        <div class="s-16 w-500"><a @click="ym(96661859,'reachGoal','go_to_cart');" href="/cart/" title="cart">Перейти в корзину</a></div>
        <div @click="opened = false" class="s-16 w-500">Продолжить покупки</div>
      </div>
      <div @click="opened = false" class="close-button"><icon-close></icon-close></div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      opened: false,
      product: {}
    }
  },
  computed: {},
  components: {
    iconClose: () => import('@/components/icon/icon-close')
  },
  created() {
    this.$bus.$on('in-cart', (product) => {
      this.opened = true
      this.product = product;
      setTimeout(() => {
        this.opened = false
      }, 5000)
    })
  }
}
</script>

<style lang="scss" scoped>
.ui-in-cart-notification {
  position: fixed;
  right: 1em;
  bottom: 1em;
  z-index: 100;
  width: 400px;
  background: #ffffff;
  box-shadow: 0px 1px 21px rgba(0, 0, 0, 0.16), 0px 0px 300px var(--color);
  border-radius: 6px;
  overflow: hidden;
}
.image {
  width: 100px;
  height: 100px;
  position: relative;
  img {
    object-fit: cover;
  }
}
.content {
  display: flex;
  align-items: center;
}
.data {
  padding-left: 1.25em;
}
.close-button {
  position: absolute;
  right: 1em;
  top: 1em;
}
.buttons {
  border-top: solid 1px rgba(0, 0, 0, 0.16);
  & > * {
    padding: 1em;
    flex-grow: 1;
    text-align: center;
    cursor: pointer;
    position: relative;
    &:not(:last-child):after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      transform: translate(0, -50%);
      height: 1em;
      background: currentColor;
      width: 1px;
      opacity: 0.3;
    }
  }
}
@media screen and (max-width: 767px) {
  .ui-in-cart-notification {
    width: calc(100vw - 30px);
    right: 15px;
  }
}
</style>
